import { useLayoutEffect } from 'react';

const useDocumentTitle = (title) => {
  useLayoutEffect(() => {
    if (title) {
      document.title = title;
    } else {
      document.title = 'TaKKa Smart';
    }
  }, [title]);
};

export default useDocumentTitle;
